// Lightweight cross-component notification for local agent state changes (the
// onboarding skip flag). Local storage is not reactive, so the launcher badge
// subscribes to this to recompute when the panel marks something seen.

const EVENT = 'webmcp:agent-state-changed'

export const notifyAgentStateChanged = (): void => {
  try {
    window.dispatchEvent(new Event(EVENT))
  } catch {
    // No window (non-browser test env) — nothing subscribes there.
  }
}

export const onAgentStateChanged = (callback: () => void): (() => void) => {
  window.addEventListener(EVENT, callback)
  return () => window.removeEventListener(EVENT, callback)
}
